import React from "react";
import AddTrackedKeywordsForm from "./AddTrackedKeywordsForm";
import BasicModal from "../shared/BasicModal/BasicModal";
import IconLabel from "../shared/IconLabel/IconLabel";
import ModalTitle from "../shared/ModalTitle/ModalTitle";
import { extractKeywords } from "../../utils/keywords";

const AddTrackedKeywords = props => {
  const onAddTrackedKeywords = txt => {
    const keywords = extractKeywords(txt);
    props.addTrackedKeywords(props.domain, props.seoDb, keywords);
  };

  return (
    <BasicModal
      openLabel={<IconLabel icon="plus-circle" label="Add Keywords" />}
      modalTitle={<ModalTitle title="Add keywords" meta={props.domain} />}
      isPerformingAction={props.isAddingTrackedKeywords}>
      <AddTrackedKeywordsForm
        onSubmit={txt => onAddTrackedKeywords(txt)}
        isAddingTrackedKeywords={props.isAddingTrackedKeywords}
      />
    </BasicModal>
  );
};

export default AddTrackedKeywords;
